const breadCrumb = "Rendimento - Consulta do Rendimento";

const routes = [
  {
    path: "/consulta-de-lancamento-de-nota-rendimento-gerado",
    name: "consulta_de_lancamento_de_nota_rendimento_gerado",
    meta: {
      //allowedPermissions: ["indicador_list"],
      requireAuth: false,
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ConsultaLancamentoDeNotaRendimentoGerado/ConsultaLancamentoDeNotaRendimentoGerado.vue"
      ),
  },
  {
    path: "/consulta-de-lancamento-de-nota-rendimento-gerado/:id/detalhes-turma",
    name: "consulta_de_lancamento_de_nota_rendimento_gerado_detalhes_turma",
    meta: {
      requireAuth: false,
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ConsultaLancamentoDeNotaRendimentoGerado/ConsultaLancamentoDeNotaRendimentoGeradoDetalhesTurma.vue"
      ),
  },
  {
    path: "/consulta-de-lancamento-de-nota-rendimento-gerado/:id/detalhes-disciplina",
    name: "consulta_de_lancamento_de_nota_rendimento_gerado_detalhes_disciplina",
    meta: {
      requireAuth: false,
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ConsultaLancamentoDeNotaRendimentoGerado/ConsultaLancamentoDeNotaRendimentoGeradoDetalhesDisciplinas.vue"
      ),
  },
];

export default routes;
